import React from "react";
import styled from "styled-components";

import Image from "../../components/common/Image";
import quoteIcon from "../../images/testimonial-quote.svg";
import {
  Card,
  QuoteDecoration,
  CardHeader,
  Avatar,
  NameBlock,
  Name,
  NameLink,
  Role,
  BodyWrapper,
  BodyText,
} from "./testimonial-card-styles";

const AvatarImage = styled(Image)`
  height: 100%;
  width: 100%;
  object-fit: cover;
`;

const TestimonialCard = ({ review, expanded }) => {
  return (
    <Card $expanded={expanded}>
      <QuoteDecoration aria-hidden="true">
        <img src={quoteIcon} alt="" />
        <img src={quoteIcon} alt="" />
      </QuoteDecoration>

      <CardHeader>
        <Avatar>
          <AvatarImage src={review.profilePic} alt={review.name} />
        </Avatar>
        <NameBlock>
          {review.linkedIn ? (
            <NameLink
              href={review.linkedIn}
              target="_blank"
              rel="noopener noreferrer"
            >
              {review.name}
            </NameLink>
          ) : (
            <Name>{review.name}</Name>
          )}
          <Role>
            {review.position} @ {review.company}
          </Role>
        </NameBlock>
      </CardHeader>

      <BodyWrapper $expanded={expanded}>
        <BodyText>{review.text}</BodyText>
      </BodyWrapper>
    </Card>
  );
};

export default TestimonialCard;
